import React from 'react'

export default function Services() {
  return (
    <>
    <section id="features">
<div className="row" data-aos="fade-down"
     data-aos-easing="linear"
     data-aos-duration="1500">



    <div className="col-lg-2 col-md-4 col-sm-6">
<div className="cards">
        <img src="images/freeshiping.png" alt="reload" />
        <h6>Free Shipping</h6>
    </div>    
    </div>

                <div className="col-lg-2 col-md-4 col-sm-6">
                    <div className="cards">
                    <img src="images/SaveMoney.png" alt="reload" />
                    
                    <h6>Save Money</h6>
                
                </div>
                            </div>

                            
                <div className="col-lg-2 col-md-4 col-sm-6">
                    <div className="cards">
                    <img src="images/promotions.png" alt="reload" />
                    <h6>Promotions</h6>
                </div>
                            </div>

                            <div className="col-lg-2 col-md-4 col-sm-6">
                                <div className="cards">
                                <img src="images/Online order.png" alt="reload" />
                                <h6>Online order</h6>
                            </div>
                                        </div>
                   
                                        <div className="col-lg-2 col-md-4 col-sm-6">
                                            <div className="cards">
                                            <img src="images/support247.png" alt="reload" />
                                            <h6>24/7 Supports</h6>
                                        </div>
                                                    </div>


                                       <div className="col-lg-2 col-md-4 col-sm-6">
                                            <div className="cards">
                                            <img src="images/happysell.png" alt="reload" />
                                            <h6>Happy Sell</h6>
                                        </div>
                                                    </div>
                                                    </div>
                                                    </section>
    </>
  )
}
